export type ComposerDraftFlush = () => Promise<void>;

const registeredFlushes = new Set<ComposerDraftFlush>();

export const registerComposerDraftFlush = (
  flush: ComposerDraftFlush,
): (() => void) => {
  registeredFlushes.add(flush);

  return () => {
    registeredFlushes.delete(flush);
  };
};

export const flushComposerDrafts = async (): Promise<void> => {
  await Promise.all([...registeredFlushes].map((flush) => flush()));
};
